import { render } from "./CertificateGenerator.vue?vue&type=template&id=177cc522"
import script from "./CertificateGenerator.vue?vue&type=script&lang=js"
export * from "./CertificateGenerator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__